import type { ICustomControlRequestReadProps } from '../../../interfaces/customControlRequestReadProps';
import { getServiceLabel } from '../../../../../../../common/customControls/getServiceLabel';
import { ProcessEntity } from '../../../../../../../common/enums/processEntity';
import { RequestStatus } from '../../../../../../../common/enums/requestStatus';
import { getDisplayName } from '../../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../../translate';
import { ReferralSmallReadButtons } from '../../../../../elements/carePathButtons/ReferralSmallReadButtons';
import { ReadCustomControlData } from '../../../../../elements/forms/ReadCustomControlData';
import { ProcessContainer } from '../../../../episodes/common';
import { ProcessItemFooter } from '../../../../episodes/ProcessItemFooter';
import { ProcessItemHeader } from '../../../../episodes/ProcessItemHeader';
import { ReloadEpisode } from '../../../../episodes/reloadEpisode';
import { RequestMessageContainer } from '../../../../episodes/RequestMessageContainer';
import { ProfessionalSummaryDataRead } from '../../../../professionalSummaryData/ProfessionalSummaryDataRead';
import { CustomControlCollapseBody } from '../../../utils/v1/CustomControlCollapseBody';
import { MedicationsRead } from '../../../utils/v1/medications/MedicationsRead';
import { ProfileImages } from '../../../utils/v1/ProfileImages';
import { RequestThumbnails } from '../../../utils/v1/RequestThumbnails';
import { SendRequestMessage } from '../../../utils/v1/SendRequestMessage';
import { TxcsMedicationsList } from '../../../utils/v1/TxcsMedicationsList';
import { PilotReferralSmallV1RequestSummary } from './PilotReferralSmallV1RequestSummary';

export function PilotReferralSmallV1RequestRead(props: ICustomControlRequestReadProps) {
    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.process.dateSent || (props.request && props.request.dateSent)}
                isFirstItem={props.isFirstItem}
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                organizationName={props.process.requesterOrganization?.name}
                practitionerName={
                    props.process.requesterPractitioner
                        ? getDisplayName(props.process.requesterPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={props.process.serviceType}
                title={getServiceLabel(props.process.code, 'request', props.process.name)}
            />

            <PilotReferralSmallV1RequestSummary {...props} />

            <CustomControlCollapseBody isOpen={props.itemState.isOpen}>
                <RequestThumbnails {...props} />

                <MedicationsRead
                    entity={ProcessEntity.request}
                    entityId={props.request.id}
                    patientUsesMedication={props.request.patientUsesMedication}
                />
                <ProfessionalSummaryDataRead request={props.request} />
                <TxcsMedicationsList requestId={props.request.id} />

                <ReadCustomControlData
                    label={'Voorgeschiedenis'}
                    value={props.request.customControlData.voorgeschiedenis}
                />
                <ReadCustomControlData
                    label={'Comorbiditeiten'}
                    value={props.request.customControlData.co_morbiditeiten}
                />
                <ReadCustomControlData
                    label={translateKey('common.remarks')}
                    value={props.request.customControlData.toelichting}
                />
                <ReadCustomControlData
                    label={translateKey('interapy.patientEmail')}
                    value={props.request.customControlData.emailadres}
                />

                <ProfileImages request={props.request} />

                {props.process.status !== RequestStatus.completed &&
                    props.process.requestMessages &&
                    props.process.requestMessages.length > 0 && (
                        <RequestMessageContainer requestMessages={props.process.requestMessages} />
                    )}
            </CustomControlCollapseBody>

            <ProcessItemFooter
                isItemOpen={props.itemState.isOpen}
                labelLess={translateKey('request.hideReferral')}
                labelMore={translateKey('request.showReferral')}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
            />

            <SendRequestMessage
                isLastItem={props.isLastItem}
                reloadAll={() => props.reloadProcess(ReloadEpisode.reloadAll)}
                request={props.request}
            />

            <ReferralSmallReadButtons {...props} />
        </ProcessContainer>
    );
}
